import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'button',
    'buttonWaiting',
    'buttonDefault',
    'message',
    'checkbox',
    'picture',
    'radio',
  ];

  connect() {
    this.selectedContent = {};

    this.checkboxTargets.forEach((el) => {
      if (el.name !== 'all') this.selectedContent[el.name] = el.checked;
    });
  }

  toggleContent(event) {
    const key = event.target.name;

    if (key !== 'all') this.selectedContent[key] = !this.selectedContent[key];

    // One-Pager and others are mutually exclusive
    if (key === 'one_pager' && this.selectedContent['one_pager'])
      this.checkboxTargets.forEach((el) => {
        if (el.name !== 'one_pager') {
          el.checked = false;
          if (el.name !== 'all') this.selectedContent[el.name] = false;
        }
      });
    else if (key !== 'one_pager' && this.selectedContent['one_pager'])
      this.checkboxTargets.forEach((el) => {
        if (el.name === 'one_pager') {
          el.checked = false;
          if (el.name !== 'all') this.selectedContent[el.name] = false;
        }
      });
    /////////

    // Check "all" when and only when all others are selected
    this.checkboxTargets.find((el) => el.name === 'all').checked =
      this.checkboxTargets
        .filter((el) => el.name !== 'all' && el.name !== 'one_pager')
        .every((el) => this.selectedContent[el.name]);

    this.togglePicture(this.selectedContent['title_page']);

    this.buttonTarget.disabled = this.selectedContentCount() === 0;
  }

  toggleContentAll(event) {
    this.checkboxTargets.forEach((el) => {
      if (!el.classList.contains('hidden'))
        if (el.name === 'one_pager') {
          el.checked = false;
          this.selectedContent[el.name] = false;
        } else if (el.name !== 'all') {
          el.checked = event.target.checked;
          this.selectedContent[el.name] = event.target.checked;
        }
    });
    this.togglePicture(this.selectedContent['title_page']);
  }

  togglePicture(enabled) {
    this.pictureTarget.classList.toggle('hidden', !enabled);
  }

  selectedContentCount() {
    const keys = Object.keys(this.selectedContent);
    const selected = keys.filter((key) => this.isSelected(key));
    return selected.length;
  }

  isSelected(key) {
    return this.selectedContent[key];
  }

  download(event) {
    event.preventDefault();

    this.abortController = new AbortController();
    this.signal = this.abortController.signal;
    this.start();

    fetch(this.urlWithParams(), { method: 'get', signal: this.signal })
      .then((response) => {
        this.stop();

        if (response.ok) {
          const filename = this.filename(response);

          return response.blob().then((blob) => {
            const a = document.createElement('a');
            a.href = URL.createObjectURL(blob);
            a.setAttribute('download', filename);
            a.click();

            // Close dropdown
            this.dropdownController.toggle();
          });
        }
        throw Error(response.statusText);
      })
      .catch((error) => {
        this.stop(error);
      });
  }

  urlWithParams() {
    let result = this.buttonTarget.dataset.href;

    // Add non-selected content as key=false
    Object.keys(this.selectedContent).forEach((key) => {
      if (!this.isSelected(key)) {
        if (result.includes('?')) result += '&';
        else result += '?';

        result += `${key}=false`;
      }
    });

    if (result.includes('?')) result += '&';
    else result += '?';

    result += `picture=${this.selectedPicture || 'generic'}`;

    return result;
  }

  filename(response) {
    const disposition = response.headers.get('Content-Disposition');

    if (disposition?.includes('attachment')) {
      const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      const matches = filenameRegex.exec(disposition);
      if (matches != null && matches[1]) {
        return matches[1].replace(/['"]/g, '');
      }
    }

    return '';
  }

  abort() {
    if (this.abortController) this.abortController.abort();
  }

  start() {
    this.buttonTarget.disabled = true;
    this.buttonWaitingTarget.classList.remove('hidden');
    this.buttonDefaultTarget.classList.add('hidden');
    this.removeError();
  }

  stop(error) {
    this.buttonTarget.disabled = false;
    this.buttonWaitingTarget.classList.add('hidden');
    this.buttonDefaultTarget.classList.remove('hidden');

    if (error) this.showError(error);
  }

  showError(message) {
    this.messageTarget.classList.remove('hidden');
    this.messageTarget.innerText = message;
  }

  removeError() {
    this.messageTarget.classList.add('hidden');
    this.messageTarget.innerText = '';
  }

  selectPicture(event, value) {
    this.selectedPicture = value || event.target.value;
  }

  selectUserPicture(event) {
    this.radioTargets.find((el) => el.value == 'user').checked = true;
    this.selectPicture(event, 'user');
  }

  get dropdownController() {
    return this.application.getControllerForElementAndIdentifier(
      this.element,
      'dropdown',
    );
  }
}
